/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of a Drop follow relationship
 * @export
 */
export const DropFollowStatus = {
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED'
} as const;
export type DropFollowStatus = typeof DropFollowStatus[keyof typeof DropFollowStatus];


export function instanceOfDropFollowStatus(value: any): boolean {
    for (const key in DropFollowStatus) {
        if (Object.prototype.hasOwnProperty.call(DropFollowStatus, key)) {
            if (DropFollowStatus[key as keyof typeof DropFollowStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DropFollowStatusFromJSON(json: any): DropFollowStatus {
    return DropFollowStatusFromJSONTyped(json, false);
}

export function DropFollowStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropFollowStatus {
    return json as DropFollowStatus;
}

export function DropFollowStatusToJSON(value?: DropFollowStatus | null): any {
    return value as any;
}

export function DropFollowStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DropFollowStatus {
    return value as DropFollowStatus;
}

